import { Filters } from "../types/games";
import { IGame } from "../../../../types/api";

const initFilters = (games: IGame[]): Filters => {
    return {
        ageLevels: {
            options: Array.from(
                new Set(games.flatMap(g => g.ageLevel.ageLevel)),
            ).sort((a, b) => {
                return parseInt(a) - parseInt(b);
            }),
            filter: undefined,
        },
        dateStart: undefined,
        dateEnd: undefined,
        leagueName: {
            options: Array.from(new Set(games.flatMap(g => g.leagueName))).sort(
                (a, b) => {
                    const ageCompare = parseInt(a) - parseInt(b);

                    if (ageCompare !== 0) {
                        return ageCompare;
                    } else {
                        return a.localeCompare(b);
                    }
                },
            ),
            filter: undefined,
        },
        location: {
            options: Array.from(
                new Set(games.flatMap(g => g.fieldName)),
            ).sort(),
            filter: undefined,
        },
        openings: true,
    };
};

export default initFilters;
